import { useState } from 'react'
import {
  Box,
  Modal,
  Button,
  Checkbox,
  Typography,
  FormControlLabel,
  CircularProgress,
} from '@mui/material'

import styles from './styles.module.scss'

type Props = {
  open: boolean
  onAccept: () => void
}

const ConsentModal = ({ open, onAccept }: Props) => {
  const [checked, setChecked] = useState(false)
  const [submitting, setSubmitting] = useState(false)

  const handleAccept = async () => {
    try {
      setSubmitting(true)
      onAccept()
    } catch (e: any) {
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <Modal
      open={open}
      className={styles.modal}
      aria-labelledby="ack-title"
      BackdropProps={{
        sx: { backgroundColor: 'rgba(0,0,0,0.65)' },
      }}
    >
      <Box className={styles.modalContent}>
        <Box className={styles.header}>
          <Typography id="ack-title" className={styles.title}>
            Acknowledgment
          </Typography>
        </Box>

        <Typography className={styles.text}>
          You are about to access a U.S. Government system. Please be aware that
          system usage may be monitored, recorded, and subject to audit.
          Unauthorized use of this system is strictly prohibited and may result
          in criminal and civil penalties. By using this system, you indicate
          your consent to such monitoring and recording.
        </Typography>
        <Typography className={styles.text}>
          Before you proceed, you must acknowledge the usage conditions
          presented here.
        </Typography>

        <FormControlLabel
          className={styles.checkbox}
          control={
            <Checkbox
              checked={checked}
              onChange={(e) => setChecked(e.target.checked)}
              color="primary"
              size="small"
            />
          }
          label="I have read and agree to the terms above."
        />

        <Box className={styles.actions}>
          <Button
            variant="contained"
            color="primary"
            disabled={!checked || submitting}
            onClick={handleAccept}
            className={styles.agreeBtn}
          >
            {submitting ? (
              <CircularProgress size={18} color="inherit" />
            ) : (
              'I Agree'
            )}
          </Button>
        </Box>
      </Box>
    </Modal>
  )
}

export default ConsentModal
